import React from 'react';
import { useTranslation } from 'react-i18next';
import { DefaultWidgetWithHeader } from '../../_lib/components/Widget';
import { Widget as WidgetShape } from '../../types/api/Widget';
import { WidgetType } from '../../types/api/ElementType';
import { FavoritedPagesBlock } from '../../_blocks/FavoritedPages';
import { Namespace } from '../../translation/namespace';
import { Icons } from '../../components/atoms/SVG';

export type FavoritedPagesWidget = WidgetShape<[FavoritedPagesBlock], WidgetType.favoritedpages>;

export function FavoritedPagesWidget({ blocks, elementType, ...headerProps }: FavoritedPagesWidget) {
  const { t } = useTranslation(Namespace.Widget);

  return (
    <DefaultWidgetWithHeader
      {...headerProps}
      icon={Icons.FAVOURITE_HEART}
      title={t(`header.${elementType}`)}
      widgetType={elementType}
      hierarchy={3}
    >
      <FavoritedPagesBlock {...blocks[0]} />
    </DefaultWidgetWithHeader>
  );
}
